import {
    apiRequest,
    skpensiunCreate,
    masterRank,
    masterWorkUnit
} from "../../../../../services/adapters/kepegawaian/skpensiunService"

class CreateRepository {

    fetchRank = async (query) => {
        return await apiRequest("get", masterRank, {
            params: query
        }, true)
    }

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", skpensiunCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository